export default "__VITE_ASSET__9i3elkY8__"